import React from 'react';
import CategoryList from './CategoryList';
import CustomNotice from '../../shared/CustomNotice';

const ServiceSelectionView = ({ 
  categories,
  services,
  selectedServices,
  onServiceToggle,
  isLoading,
  primaryColor,
  onContinue,
  continueDisabled,
  NavigationButtons,
  isAdmin = false,
  hasCustomPrices = false,
  salonConfig = {}
}) => {
  const customNotices = salonConfig?.customNotices || {};
  
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-4 mb-4">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3].map(i => (
              <div key={i} className="h-20 bg-gray-100 rounded-lg"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4">
      <h2 className="text-xl font-semibold mb-4">Selecione os serviços</h2>
      
      {/* Aviso de preços customizados */}
      {hasCustomPrices && customNotices.pricingNotice?.enabled && (
        <CustomNotice 
          message={customNotices.pricingNotice.message || "Os preços podem variar de acordo com o profissional selecionado"}
          variant={customNotices.pricingNotice.variant || "gray"} 
        />
      )}
      
      {/* Aviso personalizado geral */}
      {customNotices.generalNotice?.enabled && 
       (customNotices.generalNotice.displayLocation === 'all' || 
        customNotices.generalNotice.displayLocation === 'serviceSelection') && (
        <CustomNotice 
          message={customNotices.generalNotice.message} 
          variant={customNotices.generalNotice.variant || "gray"} 
        />
      )}
      
      {categories.length === 0 || services.length === 0 ? (
        <p className="text-gray-500 text-center py-4">
          Nenhum serviço disponível no momento
        </p>
      ) : (
        <>
          {categories.map(category => (
            <CategoryList 
              key={category.id}
              category={category}
              services={services.filter(s => s.categoria === category.id)}
              selectedServices={selectedServices}
              onServiceToggle={onServiceToggle}
              highlightColor={primaryColor}
              isAdmin={isAdmin}
            />
          ))}
          
          {selectedServices.length > 0 && (
            <div className="mt-4 p-3 bg-gray-50 rounded-lg">
              <p className="text-sm">
                <span className="font-medium">{selectedServices.length}</span> {selectedServices.length === 1 ? 'serviço selecionado' : 'serviços selecionados'}
              </p>
            </div>
          )}
        </>
      )}
      
      <NavigationButtons 
        onContinue={onContinue}
        continueDisabled={continueDisabled}
        continueLabel="Continuar"
        showBack={false}
        primaryColor={primaryColor}
      />
    </div>
  );
};

export default ServiceSelectionView; 